import type { SavedUserInfo } from '@shared/lib/saved-user-info'
import {
  getSavedUserInfo,
  removeSavedUserInfo,
  setSavedUserInfo,
} from '@shared/lib/saved-user-info'
import { MenuRow } from '@shared/ui/menu-row'
import { useState } from 'react'
import { HiMiniBookmarkSquare, HiMiniPencilSquare, HiMiniTrash } from 'react-icons/hi2'
import { toast } from 'sonner'
import { SavedInfoDrawer } from './saved-info-drawer'

export function SavedInfoSection() {
  const [savedInfo, setSavedInfo] = useState(getSavedUserInfo)
  const [drawerMode, setDrawerMode] = useState<'add' | 'edit' | null>(null)

  const handleSave = (info: Omit<SavedUserInfo, 'savedAt'>) => {
    setSavedUserInfo(info)
    setSavedInfo({ ...info, savedAt: Date.now() })
    setDrawerMode(null)
    toast.success('저장되었어요')
  }

  const handleDelete = () => {
    removeSavedUserInfo()
    setSavedInfo(null)
    toast('삭제되었어요')
  }

  if (!savedInfo) {
    return null
  }

  return (
    <>
      <MenuRow.Accordion icon={HiMiniBookmarkSquare} label="이 브라우저에 저장된 정보" defaultOpen>
        <div className="flex justify-between pt-1 px-4 gap-1">
          <div>
            <div className="typo-label font-semibold text-foreground">{savedInfo.name}</div>
            <p className="flex gap-1">
              <span className="typo-label text-muted-foreground">
                {`${savedInfo.birthYear}.${savedInfo.birthMonth.padStart(2, '0')}.${savedInfo.birthDay.padStart(2, '0')} (${savedInfo.isLunar ? '음력' : '양력'})`}{' '}
                /
              </span>
              <span className="typo-label text-muted-foreground">
                {savedInfo.birthTime || '모름'}
              </span>
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              className="flex size-6 cursor-pointer items-center justify-center rounded-sm text-muted-foreground/40 transition-colors hover:bg-muted/20 hover:text-muted-foreground"
              onClick={(e) => {
                e.stopPropagation()
                setDrawerMode('edit')
              }}
              aria-label="저장된 정보 수정"
            >
              <HiMiniPencilSquare className="typo-title" />
            </button>
            <button
              type="button"
              className="flex size-6 cursor-pointer items-center justify-center rounded-sm text-muted-foreground/40 transition-colors hover:bg-muted/20 hover:text-muted-foreground"
              onClick={(e) => {
                e.stopPropagation()
                handleDelete()
              }}
              aria-label="저장된 정보 삭제"
            >
              <HiMiniTrash className="typo-title" />
            </button>
          </div>
        </div>
      </MenuRow.Accordion>

      <SavedInfoDrawer
        isOpen={drawerMode !== null}
        onOpenChange={(open) => {
          if (!open) {
            setDrawerMode(null)
          }
        }}
        mode={drawerMode ?? 'add'}
        initialData={drawerMode === 'edit' ? savedInfo : null}
        onSave={handleSave}
      />
    </>
  )
}
